import angular from 'angular';
import './blipInsights.scss';
import { BlipInisghtsController } from './BlipInsightsController';
import BlipInsightsView from './BlipInsightsView.html';
import { applicationListStateName } from 'modules/application/list';
import { BlipInsightsFeatures } from './BlipInsightsFeatures';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { blipInsightsScriptSource } from 'app.constants';
export const blipInsightsStateName = 'auth.blipInsights';
export default angular
    .module('blipInsights', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(blipInsightsStateName, {
            url: '/blip-insights',
            controller: BlipInisghtsController,
            controllerAs: '$ctrl',
            template: BlipInsightsView,
            resolve: {
                authorization: fetchBlipInsightsPermission,
            },
            onEnter: () => {
                document.querySelectorAll('body')[0].classList.add('hide-navbar');
                return MicroFrontendService.addSource(blipInsightsScriptSource);
            },
            onExit: () => document.querySelectorAll('body')[0].classList.remove('hide-navbar'),
        });
    }])
    .name;
const fetchBlipInsightsPermission = ['$state', 'InitializeUserService', 'AccountService2', async function ($state, InitializeUserService, AccountService2) {
        await AccountService2.waitForInitialization();
        await InitializeUserService.initFeatureToggle();
        const isBlipInsightsEnabled = await BlipInsightsFeatures.isBlipInsightsEnabled();
        if (!isBlipInsightsEnabled) {
            $state.go(applicationListStateName);
        }
    }];
